/**
 * Comppoints Replacer View
 */

define(function(require, exports, module) {
    'use strict';
    const core = require('core');
    const serverUtil = require('util/server.util');
    const BaseReplacerView = require('common/base.replacer.view');
    const ComppointsModel = require('replacers/comppoints/comppoints.model');

    module.exports = BaseReplacerView.extend({

        accessRules: {
            allow: ['user']
        },

        // shared model for all compoints views
        model: new ComppointsModel(),

        tagName: 'span',

        events: {
            'tap .fn-convert-to-money': 'convertAction'
        },

        render: function() {
            if (this.options.name === 'loyaltypointsredeembtn') {
                this.renderButton();
            } else {
                this.renderInformation();
                this.model.fetch().always(this.renderInformation.bind(this), this.renderInformation.bind(this));
                this.listenTo(core, 'comppoints:updated', this.render);
            }

            return this;
        },

        /**
         * Render replacers, deplayed info about user compoints (total, convert, min, etc)
         */
        renderInformation: function() {
            var key, value;

            if (this.model.has('total')) {
                // get key name from replacer name (like [LOYALTY_POINTS_CONVERT])
                key = this.options.name.toLowerCase().replace('loyaltypoints', '');
                value = this.model.get(key);
                this.$el.html(value);
            } else {
                this.$el.html('-');
            }
        },

        /**
         * Render button for convert compoints to money
         * @return {[type]} [description]
         */
        renderButton: function() {
            this.$el.html(this.tmpl('compoints.button'));
        },

        /**
         * Convert user compoints to money
         * @return {Deferred}
         */
        convertAction: function() {
            return this.model.convertToMoney()
                .done(this.successConvert.bind(this))
                .fail(this.errorConvert.bind(this));
        },

        /**
         * Success action after money convertion
         */
        successConvert: function() {
            core.trigger('comppoints:updated');

            this.showInfo({
                content: this.translate('playtech.mobile.system.comppoints.successConvert'),
                variant: this.toastVariants.INFO
            });
        },

        /**
         * Error action after money convertion
         * @param  {Object} response
         */
        errorConvert: function(response) {
            this.showInfo({
                content: serverUtil.getErrorMessage(response, { tkPrefix: 'playtech.mobile.system.comppoints.error.' }),
                variant: this.toastVariants.INFO
            });
        },

        /**
         * Override close action, clear compoints model
         */
        close: function() {
            BaseReplacerView.prototype.close.call(this);
            this.model.clear();
        }

    }, {
        nameOfReplacers: [
            'LOYALTY_POINTS_MIN',
            'LOYALTY_POINTS_TOTAL',
            'LOYALTY_POINTS_RATIO',
            'LOYALTY_POINTS_CONVERT',
            'LOYALTY_POINTS_CURRENCY',
            'LOYALTY_POINTS_REDEEM_BTN'
        ]
    });

});
